import { getAvatarUrl } from '@/helpers/getAvatarUrl'
import theme from '@/theme'
import { AvatarProps, Avatar as BaseAvatar, Box } from '@chakra-ui/react'
// import Image from 'next/image'

export const Avatar = ({
  src,
  size = 'md',
  ...props
}: Omit<AvatarProps, 'src'> & { src: string | undefined | null }) => {
  const avatarSrc = src ? getAvatarUrl(src) : ''

  return (
    <BaseAvatar
      size={size}
      {...props}
      bg="ninja.500"
      loading="eager"
      ignoreFallback={true}
      src={avatarSrc}
      crossOrigin="anonymous"
    />
  )
}

export const AvatarCircle = ({
  src,
  offset = 0,
  ...props
}: Omit<AvatarProps, 'src'> & { offset?: number; src: string | undefined | null }) => {
  return (
    <Box padding={`${offset}px`} bgGradient={theme.colors.gradient.primary} rounded={'full'}>
      <Box rounded={'full'} ring={`${offset / 2}px`} ringColor={'ninja.500'}>
        <Avatar {...props} src={src} />
      </Box>
    </Box>
  )
}
